module.exports = __webpack_public_path__ + "img/side_pocket.aa750e79.png";